import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { handleApiError } from "@utils/errorHandler";
import { getDateFormat } from "@utils/datePickerUtils";
import { Dialog, Button, Anchor, Image } from "hesus-ui-kit";
import ClipLoader from "react-spinners/ClipLoader";
import PulseLoader from "react-spinners/PulseLoader";
import GlobalSummary from "./components/GlobalSummary/GlobalSummary";
import UserInfo from "@utils/UserInfo";
import {
  HeaderWrapper,
  Title,
  ButtonWrapper,
  FormBody,
  FlexRow,
  SectionContainer,
  GridRow,
  Labeltext,
  InvoiceOuter,
} from "./AddEditCentreSummary.styled";
import "./AddEditCentreSummary.scss";
import closeIcon from "@icons/ic-close-white.svg";
import enableIcon from "@icons/ic-toggle-green.svg";
import enableGreyIcon from "@icons/ic-toggle-grey.svg";
import disableIcon from "@icons/ic-disable.svg";
import enableInvoiceReadyIcon from "@icons/ic-toggle-blue-green.svg";

const AddEditCentreSummary = (props) => {
  const {
    t,
    id,
    clientOrderItemId,
    siteId,
    isEditMode,
    onClose,
    updateRefreshStatus,
    solutionId,
    centreName,
    lineGroupId,
  } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [isEntityCreating, setIsEntityCreating] = useState(false);
  const [createEntityAPIError, setCreateEntityAPIError] = useState("");
  const [summaryData, setSummaryData] = useState([]);
  const [documentShow, setDocumentShow] = useState([]);

  const userDetails = UserInfo.getUser();

  const [formData, setFormData] = useState({
    isReadyForInvoice: {
      required: true,
      value: false,
      error: "",
    },
    isInvoiced: {
      required: true,
      value: false,
      error: "",
    },
    planningDate: {
      required: true,
      value: false,
      error: "",
    },
    isGlobalSummary: {
      required: true,
      value: false,
      error: "",
    },
    haulageDocuments: [],
    centreDocuments: [],
    summaries: [],
  });

  const getReadyForInvoiceStatus = (planningLineGroups) => {
    let status = true;
    planningLineGroups.map((summary) => {
      summary?.summaries?.centreSummaries?.map((centreSummary) => {
        if (!centreSummary?.readyForInvoicing) {
          status = false;
        }
      });
      if (summary?.planningLines?.length > 0 && !summary?.summaries?.id) {
        status = false;
      }
    });
    return status;
  };

  const getInvoicedStatus = (planningLineGroups) => {
    let status = true;
    planningLineGroups.map((summary) => {
      summary?.summaries?.centreSummaries?.map((centreSummary) => {
        if (!centreSummary?.invoiced) {
          status = false;
        }
      });
      if (summary?.planningLines?.length > 0 && !summary?.summaries?.id) {
        status = false;
      }
    });
    return status;
  };

  const getPlanningDate = (planningLineGroups) => {
    let date = true;
    planningLineGroups.map((planningLineGroup) => {
      planningLineGroup?.planningLines?.map((planningLine) => {
        if (planningLine?.planningDate) {
          date = planningLine?.planningDate;
        }
      });
    });
    return date;
  };

  const getCentreUnit = (unit) => {
    if (unit && ["TON", "M3", "LOAD"].indexOf(unit) !== -1) {
      return unit;
    }
    return "";
  };

  const getTreatmentUnit = (unitObjs) => {
    let tretmentUnit = "";
    if (unitObjs.length > 1) {
      unitObjs.map((unitObj, unitIndex) => {
        if (
          !unitObj.hesusService.needCarrier &&
          unitObj.hesusService.needCenter
        ) {
          tretmentUnit = unitObj.unit;
        }
      });
    }
    if (unitObjs.length === 1) {
      tretmentUnit = unitObjs[0].unit;
    }
    return tretmentUnit;
  };

  const getTransportUnit = (unitObjs) => {
    let transportUnit = "";
    if (unitObjs.length > 1) {
      unitObjs.map((unitObj, unitIndex) => {
        if (
          unitObj.hesusService.needCarrier &&
          !unitObj.hesusService.needCenter
        ) {
          transportUnit = unitObj.unit;
        }
      });
    }
    if (unitObjs.length === 1) {
      transportUnit = unitObjs[0].unit;
    }
    return transportUnit;
  };

  const getTreatmentServiceItemId = (itemObjs) => {
    let itemId = "";
    if (itemObjs.length > 1) {
      itemObjs.map((itemObj, itemIndex) => {
        if (
          !itemObj.hesusService.needCarrier &&
          itemObj.hesusService.needCenter
        ) {
          itemId = itemObj.id;
        }
      });
    }
    if (itemObjs.length === 1) {
      itemId = itemObjs[0].id;
    }
    return itemId;
  };

  const getTransportServiceItemId = (itemObjs) => {
    let itemId = "";
    if (itemObjs.length > 1) {
      itemObjs.map((itemObj, itemIndex) => {
        if (
          itemObj.hesusService.needCarrier &&
          !itemObj.hesusService.needCenter
        ) {
          itemId = itemObj.id;
        }
      });
    }
    if (itemObjs.length === 1) {
      itemId = itemObjs[0].id;
    }
    return itemId;
  };

  const getRealisedLoads = (quantity, unitObjs) => {
    let loads = "";
    const treatmentUnit = getTreatmentUnit(unitObjs);
    if (treatmentUnit === "LOAD") {
      loads = quantity;
    }
    return loads;
  };

  useEffect(() => {
    if (summaryData?.clientOrder?.quoteId) {
      let itemData = [];
      const lineItems = [];
      let counter = 0;
      summaryData.planningLineGroups?.map((planningLineGroup, groupIndex) => {
        itemData = [];
        planningLineGroup?.planningLines?.map((planningLine, lineIndex) => {
          counter = parseInt(counter, 10) + 1;
          itemData.push({
            id: {
              value: planningLine?.id,
              error: "",
              required: true,
              name: "id_" + planningLine.id,
            },
            lineGroupId: {
              value: planningLineGroup?.id,
              error: "",
              required: true,
              name: "id_" + planningLine.id,
            },
            suppliersPlanningLineSummaryId: {
              value: planningLineGroup?.summaries?.id,
              name: "suppliersPlanningLineSummaryId_" + planningLine.id,
            },
            company: {
              value: planningLine?.haulage?.company?.name,
              error: "",
              required: true,
              name: "company_" + planningLine.id,
            },
            companyId: {
              value: planningLine?.haulage?.company?.id,
              name: "companyId_" + planningLine.id,
            },
            solutionId: {
              value: planningLine?.solution?.solutionId,
              name: "solutionId_" + planningLine.id,
            },
            centreId: {
              value: planningLine?.solution?.centre?.id,
              name: "centreId_" + planningLine.id,
            },
            centreSummaryId: {
              value: planningLineGroup?.summaries?.centreSummaries?.[0]?.id,
              name: "centreSummaryId_" + planningLine.id,
            },
            plannedQuantity: {
              value: planningLine?.quantity,
              error: "",
              required: true,
              name: "plannedQuantity_" + planningLine.id,
            },
            plannedUnit: {
              value: planningLine?.unit,
              error: "",
              required: true,
              name: "plannedUnit_" + planningLine.id,
            },
            realisedLoads: {
              value:
                isEditMode && planningLineGroup?.summaries?.centreSummaries
                  ? planningLineGroup?.summaries?.centreSummaries?.[0]
                      ?.realisedLoads
                  : getRealisedLoads(
                      planningLine?.quantity,
                      summaryData?.clientOrder?.services[0]?.serviceItems
                    ),
              error: "",
              required: true,
              name: "realisedLoads_" + planningLine.id,
            },
            haulageQuantity: {
              value:
                isEditMode && planningLineGroup?.summaries?.centreSummaries
                  ? planningLineGroup?.summaries?.centreSummaries?.[0]
                      ?.haulierSummary?.quantity
                  : "",
              error: "",
              required: true,
              name: "haulageQuantity_" + planningLine.id,
            },
            wasHaulageFilled: {
              value:
                isEditMode && planningLineGroup?.summaries?.centreSummaries
                  ? planningLineGroup?.summaries?.centreSummaries?.[0]
                      ?.quantity !== "" &&
                    planningLineGroup?.summaries?.centreSummaries?.[0]
                      ?.quantity !== null &&
                    planningLineGroup?.summaries?.centreSummaries?.[0]
                      ?.quantity !== undefined
                  : false,
            },
            haulageUnit: {
              value:
                isEditMode && planningLineGroup?.summaries?.centreSummaries
                  ? planningLineGroup?.summaries?.centreSummaries?.[0]
                      ?.haulierSummary?.unit ?? ""
                  : getTransportUnit(
                      summaryData?.clientOrder?.services[0]?.serviceItems
                    ) ?? "",
              error: "",
              required: true,
              name: "haulageUnit_" + planningLine.id,
            },
            isDone: {
              value:
                isEditMode && planningLineGroup?.summaries?.centreSummaries
                  ? planningLineGroup?.summaries?.centreSummaries?.[0]?.isDone
                  : true ?? true,
              error: "",
              required: true,
              name: "isDone_" + planningLine.id,
            },
            isReadyForInvoicing: {
              value: isEditMode
                ? planningLineGroup?.summaries?.centreSummaries?.[0]
                    ?.readyForInvoicing
                : false ?? false,
              error: "",
              required: true,
              name: "isReadyForInvoicing_" + planningLine.id,
            },
            isSummaryInvoiced: {
              value: isEditMode
                ? planningLineGroup?.summaries?.centreSummaries?.[0]?.invoiced
                : false ?? false,
              error: "",
              required: true,
              name: "isSummaryInvoiced_" + planningLine.id,
            },
            supplierName: {
              value: planningLine?.solution?.centre?.supplierName,
            },
            centreName: {
              value: planningLine?.solution?.centre?.name,
            },
            centreQuantity: {
              value:
                isEditMode && planningLineGroup?.summaries?.centreSummaries
                  ? planningLineGroup?.summaries?.centreSummaries?.[0]?.quantity
                  : "",
              error: "",
              required: true,
              name: "centreQuantity_" + planningLine.id,
            },
            wasCentreFilled: {
              value:
                isEditMode && planningLineGroup?.summaries?.centreSummaries
                  ? planningLineGroup?.summaries?.centreSummaries?.[0]
                      ?.quantity !== "" &&
                    planningLineGroup?.summaries?.centreSummaries?.[0]
                      ?.quantity !== null &&
                    planningLineGroup?.summaries?.centreSummaries?.[0]
                      ?.quantity !== undefined
                  : false,
            },
            centreUnit: {
              value:
                isEditMode && planningLineGroup?.summaries?.centreSummaries
                  ? planningLineGroup?.summaries?.centreSummaries?.[0]?.unit ??
                    ""
                  : getCentreUnit(
                      getTreatmentUnit(
                        summaryData?.clientOrder?.services[0]?.serviceItems
                      )
                    ) ?? "",
              error: "",
              required: true,
              name: "centreUnit_" + planningLine.id,
            },
            haulageSummaryId: {
              value: isEditMode
                ? planningLineGroup?.summaries?.centreSummaries?.[0]
                    ?.haulierSummary?.id
                : "",
              name: "haulierSummaryId_" + planningLine.id,
            },
            lineCounter: {
              value: counter,
            },
            treatmentServiceItemId: {
              value: getTreatmentServiceItemId(
                summaryData?.clientOrder?.services[0]?.serviceItems
              ),
              name: "treatmentServiceItemId_" + planningLine.id,
            },
            transportServiceItemId: {
              value: getTransportServiceItemId(
                summaryData?.clientOrder?.services[0]?.serviceItems
              ),
              name: "transportServiceItemId_" + planningLine.id,
            },
            quoteItemUnit: {
              value: getTreatmentUnit(
                summaryData?.clientOrder?.services[0]?.serviceItems
              ),
              name: "quoteItemUnit_" + planningLine.id,
            },
            existingDocuments: {
              value: planningLineGroup?.summaries?.documents,
            },
            documents: {
              value: [],
              error: "",
              documentTypes: [],
            },
            documentCount: {
              value: planningLineGroup?.summaries?.documents?.length ?? 0,
              error: "",
            },
          });
        });
        lineItems.push({ items: itemData });
      });

      const formUpdatedInfo = {
        isReadyForInvoice: {
          required: true,
          value: !isEditMode
            ? false
            : getReadyForInvoiceStatus(summaryData?.planningLineGroups),
          error: "",
        },
        isInvoiced: {
          required: true,
          value: !isEditMode
            ? false
            : getInvoicedStatus(summaryData?.planningLineGroups),
          error: "",
        },
        isGlobalSummary: {
          required: true,
          value: false,
          error: "",
        },
        planningDate: {
          required: true,
          value: getPlanningDate(summaryData?.planningLineGroups),
          error: "",
        },
        haulageDocuments: [],
        centreDocuments: [],
        summaries: lineItems,
      };
      setFormData(formUpdatedInfo);
      setIsLoading(false);
    }
  }, [summaryData]);

  const fetchSummaryData = () => {
    setIsLoading(true);
    let url = `/centresSummaries/${clientOrderItemId}/solutions/${solutionId}`;
    if (lineGroupId) {
      url = `/centresSummaries/${clientOrderItemId}/planningLineGroupId/${lineGroupId}`;
    }
    axios
      .get(url)
      .then((response) => {
        if (response.data?.[0]) {
          setSummaryData(response.data?.[0]);
        }
      })
      .catch((error) => handleApiError(error));
  };

  useEffect(() => {
    fetchSummaryData();
  }, []);

  const onInvoiceChange = () => {
    setFormData({
      ...formData,
      isReadyForInvoice: {
        value: !formData.isReadyForInvoice.value,
        error: "",
        required: true,
      },
    });
  };

  const onGlobalSummaryChange = () => {
    // setFormData({
    //   ...formData,
    //   isGlobalSummary: {
    //     value: !formData.isGlobalSummary.value,
    //     error: "",
    //     required: true,
    //   },
    // });
  };

  const onChange = (e, index, serviceIndex, type) => {
    let fieldValue = "";
    if (
      ["haulageQuantity", "centreQuantity", "realisedLoads"].indexOf(type) !==
      -1
    ) {
      fieldValue = e.target.value;
    }
    if (["haulageUnit", "centreUnit"].indexOf(type) !== -1) {
      fieldValue = e.value;
    }
    if (["isDone"].indexOf(type) !== -1) {
      fieldValue = e;
    }

    formData?.summaries?.map((summaryArray, sIndex) => {
      summaryArray?.items?.map((summary, summaryIndex) => {
        if (summaryIndex === serviceIndex && sIndex === index) {
          if (type === "haulageQuantity") {
            formData.summaries[sIndex].items[
              summaryIndex
            ].haulageQuantity.value = fieldValue;
            formData.summaries[sIndex].items[
              summaryIndex
            ].haulageQuantity.error = "";
          }
          if (type === "haulageUnit") {
            formData.summaries[sIndex].items[summaryIndex].haulageUnit.value =
              fieldValue;
            formData.summaries[sIndex].items[summaryIndex].haulageUnit.error =
              "";
          }
          if (type === "centreQuantity") {
            formData.summaries[sIndex].items[
              summaryIndex
            ].centreQuantity.value = fieldValue;
            formData.summaries[sIndex].items[
              summaryIndex
            ].centreQuantity.error = "";
          }
          if (type === "centreUnit") {
            formData.summaries[sIndex].items[summaryIndex].centreUnit.value =
              fieldValue;
            formData.summaries[sIndex].items[summaryIndex].centreUnit.error =
              "";
          }
          if (type === "realisedLoads") {
            formData.summaries[sIndex].items[summaryIndex].realisedLoads.value =
              fieldValue;
            formData.summaries[sIndex].items[summaryIndex].realisedLoads.error =
              "";
          }
          if (type === "isDone") {
            formData.summaries[sIndex].items[summaryIndex].isDone.value =
              fieldValue;
            formData.summaries[sIndex].items[summaryIndex].isDone.error = "";
            if (!fieldValue) {
              formData.summaries[sIndex].items[
                summaryIndex
              ].haulageQuantity.value = 0;
              formData.summaries[sIndex].items[
                summaryIndex
              ].haulageQuantity.error = "";
              formData.summaries[sIndex].items[
                summaryIndex
              ].centreQuantity.value = 0;
              formData.summaries[sIndex].items[
                summaryIndex
              ].centreQuantity.error = "";
              formData.summaries[sIndex].items[
                summaryIndex
              ].realisedLoads.value = 0;
              formData.summaries[sIndex].items[
                summaryIndex
              ].realisedLoads.error = "";
            }
          }
        }
      });
    });
    setFormData({ ...formData });
  };

  const onDocumentUpload = (e, index, serviceIndex) => {
    formData?.summaries?.map((summaryArray, sIndex) => {
      summaryArray?.items?.map((summary, summaryIndex) => {
        if (summaryIndex === serviceIndex && sIndex === index) {
          let filesArray = summary.documents.value ?? [];
          let docTypes = summary.documents.documentTypes;
          for (let i = 0; i < e.target.files.length; i++) {
            filesArray.push(e.target.files[i]);
            docTypes.push(e.target.dataset.type);
          }
          formData.summaries[sIndex].items[summaryIndex].documents.value =
            filesArray;

          formData.summaries[sIndex].items[
            summaryIndex
          ].documents.documentTypes = docTypes;

          formData.summaries[sIndex].items[summaryIndex].documents.error = "";

          formData.summaries[sIndex].items[summaryIndex].documentCount.value =
            filesArray.length +
            formData.summaries[sIndex].items[summaryIndex].existingDocuments
              .value.length;
        }
      });
    });
    setFormData({ ...formData });
  };

  const onDeleteDocument = (index, serviceIndex, documentId, type) => {
    formData?.summaries?.map((summaryArray, sIndex) => {
      summaryArray?.items?.map((summary, summaryIndex) => {
        if (summaryIndex === serviceIndex && sIndex === index) {
          if (type === "deleteExisting") {
            const filesArray = summary.existingDocuments.value;
            const documents = filesArray.filter(
              (item) => item.id !== documentId
            );
            formData.summaries[sIndex].items[
              summaryIndex
            ].existingDocuments.value = documents;
            formData.summaries[sIndex].items[summaryIndex].documentCount.value =
              formData.summaries[sIndex].items[summaryIndex].documents.value
                ?.length + documents.length;
          }
          if (type === "deleteNewDocument") {
            const filesArray = summary.documents.value;
            const docTypes = summary.documents.documentTypes;
            docTypes.splice(documentId, 1);
            const fileListArr = Array.from(filesArray);
            fileListArr.splice(documentId, 1); // here u remove the file
            // recreate file object
            let updatedDocs = [];
            let newUpdatedDocs = [];
            const dT = new DataTransfer();
            if (fileListArr.length > 0) {
              for (let file of fileListArr) {
                dT.items.add(file);
              }
              updatedDocs = dT.files;
              if (!Array.isArray(updatedDocs)) {
                // convert obj into array
                Object.keys(updatedDocs).forEach((key) => {
                  newUpdatedDocs.push(updatedDocs[key]);
                });
              } else {
                newUpdatedDocs = updatedDocs;
              }
            }
            formData.summaries[sIndex].items[summaryIndex].documents.value =
              newUpdatedDocs;
            formData.summaries[sIndex].items[
              summaryIndex
            ].documents.documentTypes = docTypes;

            formData.summaries[sIndex].items[summaryIndex].documentCount.value =
              formData.summaries[sIndex].items[summaryIndex].existingDocuments
                .value?.length + newUpdatedDocs.length;
          }
        }
      });
    });
    setFormData({ ...formData });
  };

  const validateForm = () => {
    let hasAtLeastOneFilledSummary = false;
    let hasValidationError = false;
    const unitArray = [];

    formData?.summaries?.map((summaryArray, sIndex) => {
      summaryArray?.items?.map((summary, summaryIndex) => {
        // if (formData.summaries[sIndex].items[summaryIndex].isDone.value) {
        const item = formData.summaries[sIndex].items[summaryIndex];

        // Check if both services are available (treatment and transport separated/combined services)
        const hesusService =
          summaryData?.clientOrder?.services[0]?.serviceItems[0]?.hesusService;
        const hasBothServices =
          (!hesusService?.needCombination &&
            hesusService?.needCenter &&
            hesusService?.needCarrier) ||
          (hesusService?.needCombination &&
            !hesusService?.needCenter &&
            hesusService?.needCarrier) ||
          (hesusService?.needCombination &&
            hesusService?.needCenter &&
            !hesusService?.needCarrier);

        // Check if haulage is filled (has quantity)
        const isHaulageFilled =
          item.haulageQuantity.value !== "" &&
          item.haulageQuantity.value !== null;

        // Check if centre is filled (has quantity)
        const isCentreFilled =
          item.centreQuantity.value !== "" &&
          item.centreQuantity.value !== null;

        // Check if services were originally filled (for edit mode)
        const wasHaulageFilled = item.wasHaulageFilled?.value || false;
        const wasCentreFilled = item.wasCentreFilled?.value || false;

        if (hasBothServices) {
          // Track if this row has any data filled
          const bothEmpty = !isHaulageFilled && !isCentreFilled;
          const bothFilled = isHaulageFilled && isCentreFilled;

          if (bothFilled) {
            hasAtLeastOneFilledSummary = true;
          }

          if (isEditMode) {
            // Edit mode: count previously filled rows as valid (even if now empty for deletion)
            if (wasHaulageFilled || wasCentreFilled) {
              hasAtLeastOneFilledSummary = true;
            }

            // Edit mode validation for combined services
            if (wasHaulageFilled && wasCentreFilled) {
              // Both were previously filled: allow both empty OR both filled, but not just one empty
              if (!bothEmpty && !bothFilled) {
                // One is empty, one is filled - show error on the empty one
                if (!isHaulageFilled) {
                  item.haulageQuantity.error = "FIELD_REQUIRED";
                  hasValidationError = true;
                }
                if (!isCentreFilled) {
                  item.centreQuantity.error = "FIELD_REQUIRED";
                  hasValidationError = true;
                }
              }
            } else {
              // Only one was previously filled: that one cannot be emptied
              if (wasHaulageFilled && !isHaulageFilled) {
                item.haulageQuantity.error = "FIELD_REQUIRED";
                hasValidationError = true;
              }
              if (wasCentreFilled && !isCentreFilled) {
                item.centreQuantity.error = "FIELD_REQUIRED";
                hasValidationError = true;
              }
            }
          } else if (!bothEmpty && !bothFilled) {
            // Creation mode: show error only if one is filled and one is not

            // One is filled, one is empty - show error on the empty one
            if (!isHaulageFilled) {
              item.haulageQuantity.error = "FIELD_REQUIRED";
              hasValidationError = true;
            }
            if (!isCentreFilled) {
              item.centreQuantity.error = "FIELD_REQUIRED";
              hasValidationError = true;
            }
          }

          // If haulage is filled, validate haulage unit
          if (isHaulageFilled && item.haulageUnit.value === "") {
            item.haulageUnit.error = "FIELD_REQUIRED";
            hasValidationError = true;
          }
          if (isCentreFilled && item.centreUnit.value === "") {
            // If centre is filled, validate centre unit
            item.centreUnit.error = "FIELD_REQUIRED";
            hasValidationError = true;
          }
          if (
            isCentreFilled &&
            item.centreUnit.value !== "" &&
            unitArray.indexOf(item.centreUnit.value) === -1
          ) {
            unitArray.push(item.centreUnit.value);
          }
          if (unitArray.length > 1) {
            item.centreUnit.error = "CENTRE_SUMMARY_VOLUMETRY_UNIT_ERROR";
            hasValidationError = true;
          }
        } else {
          // Single service validation (centre only)
          // Track if this row has any data filled
          if (isCentreFilled) {
            hasAtLeastOneFilledSummary = true;
          }

          if (
            !isCentreFilled &&
            !item.realisedLoads.value &&
            item.realisedLoads.value !== 0 &&
            isEditMode
          ) {
            hasAtLeastOneFilledSummary = true;
          }

          // If centre is filled, validate centre unit
          if (isCentreFilled && item.centreUnit.value === "") {
            item.centreUnit.error = "FIELD_REQUIRED";
            hasValidationError = true;
          }
          if (
            isCentreFilled &&
            item.centreUnit.value !== "" &&
            unitArray.indexOf(item.centreUnit.value) === -1
          ) {
            unitArray.push(item.centreUnit.value);
          }
          if (unitArray.length > 1) {
            item.centreUnit.error = "CENTRE_SUMMARY_VOLUMETRY_UNIT_ERROR";
            hasValidationError = true;
          }

          // Treatment only service - validate realisedLoads if needed
          if (
            !hesusService?.needCombination &&
            hesusService?.needCenter &&
            !hesusService?.needCarrier
          ) {
            const treatmentUnit = getTreatmentUnit(
              summaryData?.clientOrder?.services[0]?.serviceItems
            );
            if (
              isCentreFilled &&
              !item.realisedLoads.value &&
              item.realisedLoads.value !== 0 &&
              treatmentUnit === "LOAD"
            ) {
              item.realisedLoads.error = "FIELD_REQUIRED";
              hasValidationError = true;
            }
          }
        }
        // }
      });
    });

    // Form is valid only if: at least one summary is filled AND no validation errors
    const isFormValid = hasAtLeastOneFilledSummary && !hasValidationError;

    if (!isFormValid) {
      setFormData({ ...formData });
    }
    return isFormValid;
  };

  const isDeleteStatus = (data, treatmentOnly) => {
    let isDelete = false;
    if (data.isDone.value) {
      if (treatmentOnly) {
        if (data.centreQuantity.value === "") {
          isDelete = true;
        }
      }
      if (!treatmentOnly) {
        if (
          data.haulageQuantity.value === "" ||
          data.centreQuantity.value === ""
        ) {
          isDelete = true;
        }
      }
    }
    return isDelete;
  };

  const getFormData = () => {
    const dataModified = new FormData();
    formData?.summaries.map((summaryArray, index) => {
      summaryArray?.items?.map((summary, summaryIndex) => {
        // Check if both services are empty - skip this row in create mode
        const isHaulageFilled =
          summary.haulageQuantity.value !== "" &&
          summary.haulageQuantity.value !== null;
        const isCentreFilled =
          summary.centreQuantity.value !== "" &&
          summary.centreQuantity.value !== null;

        const wasHaulageFilled = summary.wasHaulageFilled?.value || false;
        const wasCentreFilled = summary.wasCentreFilled?.value || false;

        let haulierData = {};
        let treatmentOnly = true;
        const hesusService =
          summaryData?.clientOrder?.services[0]?.serviceItems[0]?.hesusService;
        const hasBothServices =
          (!hesusService?.needCombination &&
            hesusService?.needCenter &&
            hesusService?.needCarrier) ||
          (hesusService?.needCombination &&
            !hesusService?.needCenter &&
            hesusService?.needCarrier) ||
          (hesusService?.needCombination &&
            hesusService?.needCenter &&
            !hesusService?.needCarrier);
        // Skip row if both are empty and isDone is true (in create mode, don't send empty rows)
        if (
          hasBothServices &&
          !isHaulageFilled &&
          !isCentreFilled &&
          !wasCentreFilled &&
          !wasHaulageFilled &&
          summary.isDone.value
        ) {
          return;
        }

        if (
          !hasBothServices &&
          !isCentreFilled &&
          !wasCentreFilled &&
          summary.isDone.value
        ) {
          return;
        }

        if (hasBothServices) {
          treatmentOnly = false;
          haulierData = {
            id: summary.haulageSummaryId?.value,
            quantity: summary.haulageQuantity.value,
            unit: summary.haulageUnit.value,
            isDone: summary.isDone.value,
            haulierId: summary.companyId.value,
            readyInvoicing: formData.isReadyForInvoice.value,
          };
        }
        const data = {
          suppliersPlanningSummaryId:
            summary?.suppliersPlanningLineSummaryId?.value ?? "",
          treatmentServiceItemId: summary?.treatmentServiceItemId?.value ?? "",
          transportServiceItemId: summary?.transportServiceItemId?.value ?? "",
          planningLineId: summary?.id?.value ?? "",
          haulier: haulierData,
          centre: {
            id: summary.centreSummaryId?.value,
            realisedLoad: summary.realisedLoads.value,
            quantity: summary.centreQuantity.value,
            unit: isEditMode
              ? summary.centreUnit.value
              : summary.centreUnit.value == ""
              ? summary.quoteItemUnit.value
              : summary.centreUnit.value,
            isDone: summary.isDone.value,
            solutionId: summary.solutionId.value,
            centreId: summary.centreId.value,
            readyInvoicing: formData.isReadyForInvoice.value,
          },
          delete: isEditMode ? isDeleteStatus(summary, treatmentOnly) : false,
        };
        if (summary.documents.value?.length > 0) {
          for (let i = 0; i < summary.documents.value.length; i++) {
            dataModified.append(
              `documents[${index}][${i}][document][type]`,
              summary.documents.documentTypes[i]
            );
            dataModified.append(
              `documents[${index}][${i}][document][filename]`,
              summary.documents.value[i].name
            );
            dataModified.append(
              `documents[${index}][${i}][document][file]`,
              summary.documents.value[i]
            );
          }
        }
        if (summary.existingDocuments.value?.length > 0) {
          let i =
            summary.documents.value.length > 0
              ? summary.documents.value.length
              : 0;
          summary.existingDocuments.value.forEach((document) => {
            dataModified.append(
              `documents[${index}][${i}][document][filename]`,
              document.fileName
            );
            dataModified.append(
              `documents[${index}][${i}][document][id]`,
              document.id
            );
            dataModified.append(
              `documents[${index}][${i}][document][file]`,
              document.fileName
            );
            dataModified.append(
              `documents[${index}][${i}][document][type]`,
              document.type.id
            );
            i += 1;
          });
        }
        dataModified.append(`lineGroupId[${index}]`, summary.lineGroupId.value);
        dataModified.append(`adminId[${index}]`, userDetails.id);
        dataModified.append(`summaries[${index}]`, JSON.stringify(data));
        dataModified.append(`jobsiteId`, siteId);
      });
    });
    return dataModified;
  };

  const onSubmit = () => {
    const isFormValid = validateForm();
    if (isFormValid) {
      const data = getFormData(formData);
      setIsEntityCreating(true);
      setCreateEntityAPIError("");
      if ([...data.keys()].some((key) => key.startsWith("summaries"))) {
        axios
          .post(`/planningSummaries`, data, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(() => {
            setIsEntityCreating(false);
            updateRefreshStatus();
            onClose();
          })
          .catch((error) => {
            setIsEntityCreating(false);
            setCreateEntityAPIError(error.response?.data?.message ?? "");
          });
      }
    }
  };

  return (
    <Dialog width="65rem">
      <div className="add-edit-haulier-summary">
        <HeaderWrapper>
          <Title>
            {t("SUMMARIES_CENTRE_FORM")} -{" "}
            {formData?.planningDate?.value
              ? getDateFormat(formData?.planningDate?.value, "YYYY-MM-DD") + " "
              : " "}
            - {centreName}
          </Title>
          <Button
            onClick={onClose}
            styles={{
              backgroundColor: "transparent",
              border: "none",
              height: "auto",
              padding: 0,
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            <Image
              src={closeIcon}
              alt="close Product price popup"
              styles={{ width: "auto" }}
            />
          </Button>
        </HeaderWrapper>
        <FormBody>
          <FlexRow>
            <SectionContainer>
              <div>
                {isLoading && (
                  <div className="suggestions-list-loading">
                    <PulseLoader color="#1bace4" size={15} />
                  </div>
                )}
                {!isLoading && (
                  <>
                    <GridRow column="1fr auto">
                      <Labeltext>
                        <Anchor
                          textDecoration="underline"
                          url={`/site/view/${siteId}/general-info`}
                          className="add-edit-other-summary__product-link"
                          target="_blank"
                        >
                          #{siteId}
                        </Anchor>{" "}
                        - {summaryData.clientOrder?.site.name}
                      </Labeltext>
                      <InvoiceOuter>
                        <Image
                          src={
                            formData?.isInvoiced?.value
                              ? enableIcon
                              : formData?.isReadyForInvoice?.value
                              ? enableInvoiceReadyIcon
                              : disableIcon
                          }
                          alt="readyforinvoice"
                          styles={{ width: "auto", marginBottom: "5px" }}
                          onClick={onInvoiceChange}
                        />
                        <Labeltext
                          margin="0 0px 0 7px"
                          color={
                            formData?.isInvoiced?.value
                              ? "#32A728"
                              : formData?.isReadyForInvoice?.value
                              ? "#008395"
                              : "#767676"
                          }
                        >
                          {t("SUMMARY_TOGGLE_READY_INVOICING")}
                        </Labeltext>
                      </InvoiceOuter>
                    </GridRow>

                    <GridRow column="auto auto 1fr">
                      <Labeltext
                        fontSize="16px"
                        color={
                          !formData?.isGlobalSummary.value
                            ? "#15aee5"
                            : "#767676"
                        }
                        fontWeight={
                          !formData?.isGlobalSummary.value ? "700" : "400"
                        }
                        margin="7px 0 0 0"
                      >
                        {t("SUMMARY_FORM_CENTRE_SIMPLE")}
                      </Labeltext>
                      <Image
                        src={
                          formData?.isGlobalSummary.value
                            ? enableGreyIcon
                            : disableIcon
                        }
                        alt="readyforinvoice"
                        styles={{ width: "auto", marginBottom: "5px" }}
                        onClick={onGlobalSummaryChange}
                      />
                      <Labeltext
                        fontSize="16px"
                        color={
                          formData?.isGlobalSummary.value
                            ? "#15aee5"
                            : "#767676"
                        }
                        fontWeight={
                          formData?.isGlobalSummary.value ? "700" : "400"
                        }
                        margin="7px 0 0 0"
                      >
                        {t("SUMMARY_FORM_CENTRE_DETAILED")}
                      </Labeltext>
                    </GridRow>
                    {!formData?.isGlobalSummary.value && (
                      <>
                        {!summaryData?.clientOrder?.services[0]?.serviceItems[0]
                          ?.hesusService?.needCombination &&
                          summaryData?.clientOrder?.services[0]?.serviceItems[0]
                            ?.hesusService?.needCenter &&
                          !summaryData?.clientOrder?.services[0]
                            ?.serviceItems[0]?.hesusService?.needCarrier &&
                          summaryData?.clientOrder?.services[0]?.serviceItems
                            ?.length === 1 && (
                            <GlobalSummary
                              summaries={formData?.summaries}
                              onChange={onChange}
                              treatmentOnly
                              documentShow={documentShow}
                              setDocumentShow={setDocumentShow}
                              isEditMode={isEditMode}
                              onDocumentUpload={onDocumentUpload}
                              onDeleteDocument={onDeleteDocument}
                              documentTypeOptions={[
                                {
                                  id: "12",
                                  label: t("TYPE_SUMMARY_HAULAGE_TICKET"),
                                },
                              ]}
                            />
                          )}

                        {((!summaryData?.clientOrder?.services[0]
                          ?.serviceItems[0]?.hesusService?.needCombination &&
                          summaryData?.clientOrder?.services[0]?.serviceItems[0]
                            ?.hesusService?.needCenter &&
                          summaryData?.clientOrder?.services[0]?.serviceItems[0]
                            ?.hesusService?.needCarrier) ||
                          (summaryData?.clientOrder?.services[0]
                            ?.serviceItems[0]?.hesusService?.needCombination &&
                            !summaryData?.clientOrder?.services[0]
                              ?.serviceItems[0]?.hesusService?.needCenter &&
                            summaryData?.clientOrder?.services[0]
                              ?.serviceItems[0]?.hesusService?.needCarrier) ||
                          (summaryData?.clientOrder?.services[0]
                            ?.serviceItems[0]?.hesusService?.needCombination &&
                            summaryData?.clientOrder?.services[0]
                              ?.serviceItems[0]?.hesusService?.needCenter &&
                            !summaryData?.clientOrder?.services[0]
                              ?.serviceItems[0]?.hesusService
                              ?.needCarrier)) && (
                          <GlobalSummary
                            summaries={formData?.summaries}
                            onChange={onChange}
                            treatmentOnly={false}
                            documentShow={documentShow}
                            setDocumentShow={setDocumentShow}
                            isEditMode={isEditMode}
                            onDocumentUpload={onDocumentUpload}
                            onDeleteDocument={onDeleteDocument}
                            documentTypeOptions={[
                              {
                                id: "12",
                                label: t("TYPE_SUMMARY_HAULAGE_TICKET"),
                              },
                              {
                                id: "10",
                                label: t("TYPE_SUMMARY_CENTRE_RECEIPT"),
                              },
                            ]}
                          />
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            </SectionContainer>
          </FlexRow>
        </FormBody>

        <ButtonWrapper>
          {createEntityAPIError && <div>{createEntityAPIError}</div>}
          <Button
            styles={{
              color: "#333",
              background: "#fff",
              marginRight: "0.32rem",
              border: "1px solid #ccc",
              "&:hover": {
                backgroundColor: "#ccc",
              },
            }}
            onClick={onClose}
          >
            {t("CANCEL")}
          </Button>
          <Button
            styles={{
              color: "white",
              background: "#1BACE4",
              border: "1px solid #1BACE4",
              "&:hover": {
                backgroundColor: "#1589b6",
              },
            }}
            onClick={onSubmit}
          >
            <>
              {isEntityCreating && <ClipLoader size={15} color="#fff" />}
              {!isEntityCreating && t("VALIDATE")}
            </>
          </Button>
        </ButtonWrapper>
      </div>
    </Dialog>
  );
};

AddEditCentreSummary.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.number,
  isEditMode: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  // updateDisputeRefeshStatus: PropTypes.func.isRequired,
  siteId: PropTypes.number.isRequired,
  lineGroupId: PropTypes.number,
};

AddEditCentreSummary.defaultProps = {
  id: null,
  isEditMode: false,
  lineGroupId: null,
};

export default withTranslation()(AddEditCentreSummary);
